import { useMemo } from "react";
import { getColumns } from "../../processor";
import { FilterTableInfo } from "./types";
import { getFilterColumnsForTable } from "./utils";

export const useFilterHeaders = <T extends Record<string, any>>(
  initialData: T[],
  columnsToHide?: string[],
  tableInfo?: FilterTableInfo
) => {
  return useMemo(() => {
    const filterColumns = tableInfo ? getFilterColumnsForTable(tableInfo) : [];
    
    const baseHeaders = getColumns(initialData).filter((item) => {
      if (columnsToHide?.includes(item)) return false;

      if (filterColumns.length > 0) {
        return filterColumns.includes(item);
      }
      
      return true;
    });

    return baseHeaders.filter((header) => {
      return initialData.some((item) => 
        item[header] !== undefined && item[header] !== null && item[header] !== ""
      );
    });
  }, [initialData, columnsToHide, tableInfo]);
};
